module.exports = "/packs/images/mission-values/juul-pods-b1408c6103a5b28d3df3ae9ae718e526.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/images/mission-values/juul-pods.jpg
// module id = 1779
// module chunks = 0